import dayjs from 'dayjs';
import { WorkTimeBreaksType, WorkTimeType } from 'shared/types';

type Props = {
	workTime: WorkTimeType | WorkTimeBreaksType;
	date?: Date;
	delay?: number;
	sameDay?: boolean;
};

/**
 * Get from & till dates for specific workTime: WorkTimeType.
 * Date will be based on "new Date()".
 * Additional specific Date can be passed as second property dates will be based on it.
 * Can be required as day of week (e.g. Monday, Thursday) if is not today or tomorrow
 * */
const getDateFromWorkTime = ({
	workTime,
	date,
	delay,
	sameDay,
}: Props): {
	from: Date;
	till: Date;
	tillDelayed: Date;
	fromDelayed: Date;
} => {
	if (!workTime) {
		const date = new Date();
		return {
			from: date,
			till: date,
			fromDelayed: date,
			tillDelayed: date,
		};
	}
	const from = _formDay(workTime.from, date);
	let till = _formDay(workTime.till, date);

	if ((from.isAfter(till) || from.isSame(till)) && !sameDay) {
		till = till.add(1, 'days');
	}
	if (delay) {
		const fromDelayed = _formDay(workTime.from, date, delay);
		let tillDelayed = _formDay(workTime.till, date, delay);

		if (fromDelayed.isAfter(tillDelayed)) {
			tillDelayed = tillDelayed.add(1, 'days');
		}

		return {
			from: from.toDate(),
			till: till.toDate(),
			fromDelayed: fromDelayed.toDate(),
			tillDelayed: tillDelayed.toDate(),
		};
	}

	return {
		from: from.toDate(),
		till: till.toDate(),
		fromDelayed: from.toDate(),
		tillDelayed: till.toDate(),
	};
};

const _formDay = (time: string, date?: Date, delay?: number) => {
	const [hours, minutes] = time?.split(':');
	return dayjs(date)
		.set('hours', parseInt(hours))
		.set('minutes', parseInt(minutes))
		.set('seconds', 0)
		.set('milliseconds', 0)
		.add(delay ?? 0, 'minutes');
};

export default getDateFromWorkTime;
